import React from 'react';
import { Icon, IconProps } from './Icon';

export const CloseIcon: React.FC<IconProps> = (props) => {
  return (
    <Icon height="24" width="24" viewBox="0 0 24 24" {...props}>
      <path d="M18 6 6 18" />
      <path d="m6 6 12 12" />
    </Icon>
  );
};
